module.exports = __webpack_public_path__ + "static/media/8-7.48efc930.mp3";